import { TdesignEducationFilled } from "@/components/icons/education";
import { MaterialSymbolsPersonRounded } from "@/components/icons/person";
import { SimpleIconsHyperskill } from "@/components/icons/skill";
import { SiProjectsAltFill } from "@/components/icons/project";
import { MingcutePaper2Fill } from "@/components/icons/exp";
import { MaterialSymbolsContactSupportRounded } from "@/components/icons/contact";
import { MingcuteCertificateFill } from "@/components/icons/certificate";
import { MaterialSymbolsConnectWithoutContact } from "@/components/icons";
import { FluentEmojiHighContrastSoonArrow } from "@/components/icons/soon";

export const menus = [
    {
        content: 'Who is he?',
        icon: <MaterialSymbolsPersonRounded className="w-7 h-7 max-lg:w-4 max-lg:h-4"/>
    },
    {
        content: 'Education',
        icon: <TdesignEducationFilled className="w-7 h-7 max-lg:w-4 max-lg:h-4" />
    },
    {
        content: 'Skills',
        icon: <SimpleIconsHyperskill className="w-7 h-7 max-lg:w-4 max-lg:h-4" />
    },
    {
        content: 'Projects',
        icon: <SiProjectsAltFill className="w-7 h-7 max-lg:w-4 max-lg:h-4" />
    },
    {
        content: 'Experience',
        icon: <MingcutePaper2Fill className="w-7 h-7 max-lg:w-4 max-lg:h-4" />
    },
    {
        content: 'In Touch',
        icon: <MaterialSymbolsConnectWithoutContact className="w-7 h-7 max-lg:w-4 max-lg:h-4" />
    },
    {
        content: 'Achievement',
        icon: <MingcuteCertificateFill className="w-7 h-7 max-lg:w-4 max-lg:h-4" />
    },
    {
        content: '',
        icon: <FluentEmojiHighContrastSoonArrow className="w-9 h-9 max-lg:w-4 max-lg:h-4" />
    }
];

